export default class extends Controller {
  static targets = ["link"];

  connect() {
    App.Helpers.listenToCustomEvent(document, "month-picker:date-change", this.updateDate.bind(this));
  }

  updateDate(event) {
    const { el, newDate } = event.detail;
    if (this.element.contains(el)) {
      this.linkTarget.href = this.baseURL.replace(/DATE/g, newDate);
    }
  }

  //
  // GETTERS AND SETTERS
  //

  get baseURL() {
    return this.data.get("base-url");
  }
};



// WEBPACK FOOTER //
// ./app/javascript/stimulusControllers/data_exports/data-exports-time-entries-link-controller.js